module.exports = __webpack_public_path__ + "media/src/Shared/Assets/roamly/search_page-94f6a2092c6d098b9a841f22f04def9f919e6b048459a49119390bb3e37182a1.jpg";